import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { isEmpty } from 'lodash';
import '../../stylesheets/consentAppFrame.scss';
import { Button, Icon } from '@unite-us/ui';
var HEIGHT_DIFFERENTIAL = 130;
var DEFAULT_HEIGHT = 467;

// Set height to avoid double scrollbar (Tom's idea).
function iframeHeight() {
  var dialog = document.getElementById('consent-dialog');
  if (isEmpty(dialog)) {
    return 1200;
  }
  var screenHeight = window.innerHeight;
  if (screenHeight < 640) {
    return 320;
  } else if (screenHeight < 768) {
    return 350;
  } else if (screenHeight < 998) {
    return 400;
  }
  var paper = dialog.getElementsByClassName('dialog-paper');
  var calculatedHeight = paper[0].clientHeight - HEIGHT_DIFFERENTIAL;

  // Set a default height of 467.  On the initial load of the iframe
  // the height is not set properly causing issues on the dialog Component
  // dialog component was very small thus adjusting height only if the calculated height is larger than the default
  return calculatedHeight < DEFAULT_HEIGHT ? DEFAULT_HEIGHT : calculatedHeight;
}
// this is a pure component due to iframeHeight being called multiple times
// https://uniteus.atlassian.net/browse/UU3-9722
var ConsentAppFrame = /*#__PURE__*/function (_PureComponent) {
  _inherits(ConsentAppFrame, _PureComponent);
  var _super = _createSuper(ConsentAppFrame);
  function ConsentAppFrame(props) {
    var _this;
    _classCallCheck(this, ConsentAppFrame);
    _this = _super.call(this, props);
    _this.ref = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(ConsentAppFrame, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onBackClick = _this$props.onBackClick,
        onSetRef = _this$props.onSetRef,
        onLoad = _this$props.onLoad,
        consentAppUrl = _this$props.consentAppUrl;
      return /*#__PURE__*/React.createElement("div", {
        className: "consent-app-frame"
      }, /*#__PURE__*/React.createElement("div", {
        className: "consent-app-frame__back-button"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "text-brand-blue",
        onClick: onBackClick,
        iconLeft: /*#__PURE__*/React.createElement(Icon, {
          className: "fill-current text-brand-blue",
          icon: "IconChevronLeft"
        }),
        label: "Back"
      })), /*#__PURE__*/React.createElement("div", {
        className: "consent-app-frame__iframe-wrapper",
        style: {
          height: iframeHeight()
        }
      }, /*#__PURE__*/React.createElement("iframe", {
        title: "consent-app",
        ref: function ref(element) {
          return onSetRef(element);
        },
        frameBorder: "0",
        height: "100%",
        id: "consent-app-frame-iframe",
        scrolling: "yes",
        src: consentAppUrl,
        width: "100%",
        onLoad: onLoad
      })));
    }
  }]);
  return ConsentAppFrame;
}(PureComponent);
ConsentAppFrame.propTypes = {
  onBackClick: PropTypes.func.isRequired,
  onSetRef: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired,
  consentAppUrl: PropTypes.string.isRequired
};
export default ConsentAppFrame;
//# sourceMappingURL=ConsentAppFrame.js.map